import { createFileRoute } from '@tanstack/react-router';
import { PrivacyPolicy } from '@/components/legal';

// Public route - no auth required
export const Route = createFileRoute('/privacy-policy')({
  component: PrivacyPolicy,
});
